module.exports = {
  ShanghaiPort: '上海港',
  QingdaoPort: '青岛港',
  DeletionGuide: '删改指南',
  BusinessData: '业务资料',
  DropOffGoods: '落货',
  CounterDeletion: '柜台删单',
  CertificateOfNonBoarding: '未上船证明',
  CarrierName: '船代名称',
  Text1: '服务范围（平台支持',
  Text2: '家船公司和',
  Text3: '家船代的舱单发送，清单如下：）',
  Text4: '关于“预配舱单更改或删除”的处理指南',
  Title1: '服务范围—平台支持',
  Title2: '家船公司的VGM发送，清单如下：',
  Remark1: '上海振华（船代）',
  Remark2: '东进DJS、安通ONTO、达通EAS、泛舟PCS禁止',
  Remark3: '上海民生（船代）',
  Remark4: '民生船公司的台湾线日本线禁止。万海WHL的台湾线可以发',
  Remark5: '锦诚（船代）',
  Remark6: '锦江轮船JJ禁止',
  Remark7: '正利（船司）',
  Remark8: '“CNC—正利”的台湾线，船司代码请选择“CST—宝华”',
  Remark9: '新东（船司）',
  Remark10: '“NOS—新东”的韩国仁川线，船司代码请选择“NSI—宁波远洋”',
  Remark11: '新加坡海运（船司）',
  Remark12: '边航船公司子品牌，SEC开头的提单号可以发，船公司请选“SCO—新加坡海运”',
  Remark13: '新加坡海领船务（船司）',
  Remark14: 'FCSL-阿联酋瓦尔塔是VOLTA上海代理，船公司请选“SLS—新加坡海领船务”',
  Remark15: '上海中联（船代）',
  Remark16: '中联CUL、日照港RPS禁止',
  Remark17: '船开前，未超过船代规定的舱单截止时间，且整批舱单都未报关：',
  Remark18: 'a） 如需更改船公司、船代、提单号、船名、航次、箱号、封号、品名、箱型：需在“已发送”中选中原舱单，提交删除舱单申请，待删除完成后，再重新提交新的舱单；其中箱型仅中联/东方海外/中外运/振华四家船代错了要删，其他可直接提交修改。',
  Remark19: 'b） 如需更改除上述9类以外的信息，可在“已发送”中选中舱单，提交修改舱单申请，等待修改回执。',
  Remark20: 'c） 针对拼票（即拼箱）：',
  Remark21: 'i）如果需要修改其中某票或某几票信息，参考上述b点。',
  Remark22: 'ii）如果需要删除其中的某票或某几票，需要把同箱号下的舱单全部删除后，再重新发送新的舱单',
  Remark23: 'iii）如果需要添加1个拼票，可以直接发送该票拼票（船代为航华、鹏华时，加拼子单号必须和主单录在一起发送）',
  Remark24: '船开前，但已经超过船代规定的舱单截止时间，或者客户已报关：',
  Remark25: 'a）凡是客户已报关的，必须先反核注报关',
  Remark26: 'b）具体咨询对应船代，询问此事如何进行删改操作（具体可询问我司客服）',
  Remark27: 'c）如已放行，需递送纸质文件至船代柜台办理取消“已放行”标志（具体可询问我司客服）',
  Remark28: '船开后，申请删单：',
  Remark29: 'a）凡是客户已报关的，必须先注销报关单。',
  Remark30: 'b）需递送纸质文件至船代柜台办理删单操作：一般来说，至少需要以下4种材料（仅供参考）：《删单申请书》、《报关单》、《删单情况说明》、《海关信息网上的通转状态查询页面的截图》（我司可提供代办服务，具体详询客服）',
  Remark31: '附：各家船代柜台服务地址',
  CompanyName1: '上海外代',
  CompanyName2: '上海中外运',
  CompanyName3: '上海联合',
  CompanyName4: '上海华港',
  CompanyName5: '上海顺德',
  CompanyName6: '上海航华',
  CompanyName7: '上海民生',
  CompanyName8: '上海鹏华',
  CompanyName9: '上海鹏海',
  CompanyName10: '上海中联（中和）',
  CompanyName11: '上海振华',
  CompanyName12: '新海',
  CompanyName13: '锦诚',
  CompanyName14: '东方海外',
  CompanyName15: '上港联合',
  CompanyName16: '上海中联',
  CompanyName17: '鹏华',
  CompanyAddress1: '虹口区吴淞路531号5楼',
  CompanyAddress2: '福建中路188号三楼大厅',
  CompanyAddress3: '虹口区东大名路916号一楼',
  CompanyAddress4: '东大名路501号1601室',
  CompanyAddress5: '海伦路440号2701室',
  CompanyAddress6: '虹口区黄浦路99号2楼',
  CompanyAddress7: '大连路1619号骏丰国际财富广场16楼',
  CompanyAddress8: '杨浦区四平路1063号中天大厦1幢5楼501,502,508室',
  CompanyAddress9: '延安东路700号1807-1809室',
  CompanyAddress10: '虹口区东大名路908号24楼',
  CompanyAddress11: '延安东路700号港泰广场21楼',
  CompanyAddress12: '虹口区天潼路133号上海家化金融大厦8楼',
  CompanyAddress13: '延安东路1200号8楼',
  CompanyAddress14: '延安中路841号20楼'
}
